export const phases = [
  { label: "Preparing", icon: "pi pi-cog" },
  { label: "Downloading", icon: "pi pi-download" },
  { label: "Merging", icon: "pi pi-sitemap" },
  { label: "Validating", icon: "pi pi-check-square" },
  { label: "Finalizing", icon: "pi pi-check-circle" },
];

export const tips = [
  "Tip: You can keep working in other sections while we sync.",
  "Ensuring data won't be duplicated.",
  "Optimizing data for a faster dashboard.",
  "Verifying data integrity...",
  "Almost there, thanks for your patience.",
];
